export function displayPopMessage(message) {
    let popElm = document.querySelector('.top-pop-message');
    popElm.innerHTML = popElm.innerHTML + `
    <div class="alert alert-warning alert-dismissible fade show" role="alert">
        ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    `;
}

export function showLoadingIcon() {
    document.querySelector('.cover-when-loading').classList.remove('d-none');
}

export function hideLoadingIcon() {
    document.querySelector('.cover-when-loading').classList.add('d-none');
}

export function fetchIdFromUrlPath() {
    let currentPath = window.location.pathname;
    if (currentPath !== '/') {
        currentPath = (currentPath[0] === '/') ? (currentPath.slice(1, currentPath.length)) : (currentPath);
        currentPath = (currentPath[currentPath.length - 1] === '/') ? (currentPath.slice(0, currentPath.length - 1)) : (currentPath);
        // console.log(currentPath);
        let pathArray = currentPath.split('/');
        // console.log(pathArray);
        if (pathArray.length === 2 && (pathArray[0] === 'simple' || pathArray[0] === 'ultimate')) {
            return (pathArray[1]);
        }
    }
    return null;
}

export function getOpposite(iAm) {
    if (iAm == 'X') {
        return 'O'
    } else {
        return 'X'
    }    
}